<template>
  <!-- Generates Bing Session key once office data is loaded! -->
  <BingSession v-if="getOfficeIRP !== 0" />

  <!-- Error modal -->
  <template 
    v-if="this.errorModal === true">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header bg-danger">
                <h5 class="modal-title">Error: Unable to Load Offices</h5>
              </div>
              <div class="modal-body">
                <p>
                  We're unable to load the locations of the NCDMV offices.
                </p>
                <p>
                  Please <strong>refresh</strong> your browser to try to
                  again.  
                </p>
              </div>
              <div class="modal-footer">
                <span
                  type="button"
                  class="btn btn-secondary"
                  v-on:click="errorModal = false"
                  >Ok</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </template>

  <PublicOfficeLocations />
  <InternetWaitTimeLoader />
<!-- </div> -->
</template>

<script>
/*eslint no-useless-escape: */
import InternetWaitTimeLoader from "./components/InternetWaitTimeLoader.vue";
import PublicOfficeLocations from "./components/PublicOfficeLocations.vue";
import BingSession from "./components/BingSession.vue";
import { isValidCheck } from "./utils/validationUtils";
import { useRootStore } from "./store";

export default {
name: "App",
components: {
  PublicOfficeLocations,
  BingSession,
  InternetWaitTimeLoader,
},
data() {
  return {
    rootStore: useRootStore(),
    errorModal: false,
    countdown: "",
    holidayLoaded:false,  // Has the JS array of dates of holidays been loaded?
  };
},
watch: {
    // When this becomes true, start he rest of the app loading
    holidayLoaded: function(){
      if(this.holidayLoaded === true){
        
        // Start loading
        this.loadOfficeLoations();
        this.checkForMode();
      }
    },

  getUserLocation: function () {
    // when geolocation happens, perform bing rest call to get better data
    this.enhanceUserLocationData(
      this.getUserLocation?.Lat,
      this.getUserLocation?.Long
    );
  },
},
created() {
  this.rootStore = useRootStore(),
  // First things first - check to see if today is a state holiday
  this.fetchMapConfigFile()
  // this.fetchDatesCheckForHoliday()
},
  async mounted() {
    // Loads zip/city/county/region file into Vuex for use in dropdown
    // This data is also used in SearchBox component to load the search dropdown values
    this.rootStore.fetchZipCityCountydata();
    
    // this.loadOfficeLoations();
    // this.checkForMode();  
  },
methods: {
 
  // This little JS file lets small configuration changes occur without reploying the whole app.
  async fetchMapConfigFile() {
    try {
      const response = await fetch('assets/configDMVoffices.js');
      const returnedConfig = await response.json();
      console.log("RULE SETTING: The following counties are allowed to offer vehicle services at their kiosks: " + returnedConfig.lpaCounties.join(", "))
      if (returnedConfig) {
        // Set LPA counties that allow kiosks
        if (isValidCheck(returnedConfig.lpaCounties)) {
          this.rootStore.SET_LPAKIOSKALLOWED(returnedConfig.lpaCounties)
        }
        // Set Bing Maps API key
        if (isValidCheck(returnedConfig.bingMapAPIKey)) {
          this.rootStore.UPDATE_MAP_API_KEY(returnedConfig.bingMapAPIKey)
        }
        let allowedIWTObj = returnedConfig?.allowedIWTDateTime
        // Set IWT Start Dates and Time Maps API key
        if (isValidCheck(allowedIWTObj)) {
          this.rootStore.SET_ALLOWED_IWT_DATE_TIME(allowedIWTObj)
        }
        if(isValidCheck(returnedConfig.iwtIntervalTime)) {
          this.rootStore.SET_IWT_WAIT_INTERVAL_TIME(returnedConfig.iwtIntervalTime)
        }
        if (returnedConfig.mapIWTPollinginterval !== undefined && returnedConfig.mapIWTPollinginterval !== null) {
          this.rootStore.SET_MAP_POLLING_INTERVAl(returnedConfig.mapIWTPollinginterval)
        }
      }
     
      // Account for holidays:
      const today = new Date().toISOString().split('T')[0]; // Today's date in YYYY-MM-DD format
      console.log("RULE SETTING: Is today a state holiday?  " + returnedConfig?.holidays.includes(today))

      if(returnedConfig?.holidays.includes(today) === true){
        return [
          // Tell the store its a holiday! 
          this.rootStore.SET_ISSTATEHOLIDAY(true),
          this.holidayLoaded = true
        ]     } 
      else{
        return [
          this.holidayLoaded = true,
        ]
      }

    } catch (error) {
      console.error('Error fetching or checking dates:', error);
      return [
          // Just in case someone didn't upload the JS file, we don't stop the app from loading
          this.holidayLoaded = true,
        ]
    }
  },




 // load Office location data from web service
 async loadOfficeLoations(data = {}){
  try{
    const response = await fetch(this.getLocationsURL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      },
      body: JSON.stringify(data), // body data type must match "Content-Type" header
      }
    )
    
    // These are the results
    const loadedOffices = await response.json();
  
    // Create variables with what's in the layers. This should probably be handled by a web worker.
    
    // DL offices with any kiosks that offer DL services
    let DLOfficeWithKiosks = loadedOffices.filter(obj => (obj.officeTypes === "license" || obj.officeTypes === "kiosk" ) && obj.temporaryOfficeStatus === "" && obj.isMobile === false)

    // Just DL offices, no kiosks:    
    let DLoffices = loadedOffices.filter(obj => obj.officeTypes === "license" && obj.temporaryOfficeStatus === "" && obj.isMobile === false)

    // Saturday DL offices including kiosks
    let DLofficesSaturdayAndKiosks = loadedOffices.filter(obj => (obj.officeTypes === "license" || obj.officeTypes === "kiosk" ) && obj.temporaryOfficeStatus === "" && obj.isMobile === false && obj.normalHours.includes("Saturday "))
    
     // Saturday DL offices, no kiosks
    let DLofficesSaturday = loadedOffices.filter(obj => obj.officeTypes === "license" && obj.temporaryOfficeStatus === "" && obj.isMobile === false && obj.normalHours.includes("Saturday "))

    // All kiosk locations
    let DLVRkiosks = loadedOffices.filter(obj => (obj.officeTypes === "kiosk") && obj.temporaryOfficeStatus === "" && obj.isMobile === false)

    // Kiosks that allow VR Transactions. Restricted by county
    let VRofficesOnlyKiosks = loadedOffices.filter(obj => (obj.officeTypes === "kiosk" && this.getLpaKioskAllowed.includes(obj.counties) && obj.temporaryOfficeStatus === ""))

    // VR offices with kiosks that allow VR transactions
    let VRofficesWithKiosks = loadedOffices.filter(obj => ((obj.officeTypes === "kiosk" && this.getLpaKioskAllowed.includes(obj.counties)) || obj.officeTypes === "irp,plate" || obj.officeTypes == "plate") && obj.temporaryOfficeStatus === "" && obj.isMobile === false) // All IRPs are plates

    // VR offices, no kiosks
    let VRoffices = loadedOffices.filter(obj => (obj.officeTypes === "irp,plate" || obj.officeTypes == "plate") && obj.temporaryOfficeStatus === "" && obj.isMobile === false) // All IRPs are plates

    // License and theft
    let LToffices = loadedOffices.filter(obj => obj.officeTypes === "lt" && obj.temporaryOfficeStatus === "" && obj.isMobile === false)
    
    // IRP Offices
    let IRPoffices = loadedOffices.filter(obj => obj.officeTypes === "irp,plate" && obj.temporaryOfficeStatus === "" && obj.isMobile === false)

   
    // And the closed offices, too

    // CLOSED DL OFFICES WITH KIOSKS
    let closedDLOfficeWithKiosks = loadedOffices.filter(obj => (obj.officeTypes === "license" || obj.officeTypes === "kiosk") && obj.temporaryOfficeStatus === "Closed" && obj.isMobile === false)
  
    // CLOSED Just DL offices, no kiosks:    
    let closedDLoffices = loadedOffices.filter(obj => obj.officeTypes === "license" && obj.temporaryOfficeStatus === "Closed" && obj.isMobile === false)
  
    // CLOSED All kiosk locations
    let closedOfficeKioskDLVR = loadedOffices.filter(obj => (obj.officeTypes === "kiosk") && obj.temporaryOfficeStatus === "Closed" && obj.isMobile === false)
  
    // CLOSED VR offices with kiosks
    let closedVRofficesWithKiosks = loadedOffices.filter(obj => ((obj.officeTypes === "kiosk" && this.getLpaKioskAllowed.includes(obj.counties)) || obj.officeTypes === "irp,plate" || obj.officeTypes == "plate" || obj.officeTypes === "kiosk,plate") && obj.temporaryOfficeStatus === "Closed" && obj.isMobile === false) // All IRPs are plates
  
    // CLOSED VR offices, no kiosks
    let closedVRoffices = loadedOffices.filter(obj => (obj.officeTypes === "irp,plate" || obj.officeTypes == "plate") && obj.temporaryOfficeStatus === "Closed" && obj.isMobile === false) // All IRPs are plates
  
    // CLOSED License and theft
    let closedLToffices = loadedOffices.filter(obj => obj.officeTypes === "lt" && obj.temporaryOfficeStatus === "Closed" && obj.isMobile === false)
    
    // CLOSED IRP Offices
    let closedIRPoffices = loadedOffices.filter(obj => obj.officeTypes === "irp,plate" && obj.temporaryOfficeStatus === "Closed" && obj.isMobile === false)
  
    // Debugging statement for the console!
    const officeCountClosed = [
      {"Closed Count":"DL Offices with Kiosks","Count":closedDLOfficeWithKiosks.length},
      {"Closed Count":"DL Offices no Kiosks","Count":closedDLoffices.length},
      {"Closed Count":"All Kiosk Locations","Count":closedOfficeKioskDLVR.length},
      {"Closed Count":"VR Offices with Kiosks","Count":closedVRofficesWithKiosks.length},
      {"Closed Count":"VR Offices, no Kioks","Count":closedVRoffices.length},
      {"Closed Count":"License Theft","Count":closedLToffices.length},
      {"Closed Count":"IRP Offices","Count":closedIRPoffices.length}
    ]

    const officeCountOpen = [
      {"Open count":"Saturday DL Offices with Kiosks","Count":DLofficesSaturdayAndKiosks.length},
      {"Open count":"DL Offices with Kiosks","Count":DLOfficeWithKiosks.length},
      {"Open count":"DL Offices no Kiosks","Count":DLoffices.length},
      {"Open count":"All Kiosk Locations","Count":DLVRkiosks.length},
      {"Open count":"VR Offices with Kiosks","Count":VRofficesWithKiosks.length},
      {"Open count":"VR Offices, no Kioks","Count":VRoffices.length},
      {"Open count":"License Theft","Count":LToffices.length},
      {"Open count":"IRP Offices","Count":IRPoffices.length}
    ]

    console.table(officeCountOpen)
    console.table(officeCountClosed)

    // Send all this data to the store:
    let officeVuexLoader = [
      {
        "store": "SET_OFFICE_DL_WITHKIOSKS",
        "data": DLOfficeWithKiosks
      },
      {
        "store": "SET_OFFICE_DL",
        "data": DLoffices
      },
      {
        "store": "SET_OFFICE_DL_SATURDAYWITHKIOSKS",
        "data": DLofficesSaturdayAndKiosks
      },
      {
        "store": "SET_OFFICE_DL_SATURDAY",
        "data": DLofficesSaturday
      },
      {
        "store": "SET_OFFICE_ALL_KIOSKS",
        "data": DLVRkiosks
      },
      {
        "store": "SET_OFFICE_LPA_WITHKIOSKS",
        "data": VRofficesWithKiosks
      },
      {
        "store": "SET_OFFICE_LPA",
        "data": VRoffices
      },
      {
        "store": "SET_OFFICE_ONLY_LPA_KIOSKS",
        "data": VRofficesOnlyKiosks
      },
      {
        "store": "SET_OFFICE_IRP",
        "data": IRPoffices
      },
      {
        "store": "SET_OFFICE_LT",
        "data": LToffices
      },
      {
        "store": "SET_OFFICE_DL_WITHKIOSKS_CLOSED",
        "data": closedDLOfficeWithKiosks
      },
      {
        "store": "SET_OFFICE_DL_CLOSED",
        "data": closedDLoffices
      },
      {
        "store": "SET_OFFICE_ALL_KIOSKS_CLOSED",
        "data": closedOfficeKioskDLVR
      },
      {
        "store": "SET_OFFICE_LPA_WITHKIOSKS_CLOSED",
        "data": closedVRofficesWithKiosks
      },
      {
        "store": "SET_OFFICE_LPA_CLOSED",
        "data": closedVRoffices
      },
      {
        "store": "SET_OFFICE_IRP_CLOSED",
        "data": closedIRPoffices
      },
      {
        "store": "SET_OFFICE_LT_CLOSED",
        "data": closedLToffices
      },
    ]

    officeVuexLoader.forEach(o => {
      if(this.rootStore[o.store]) {
        this.rootStore[o.store](o.data);
      }
    })
    
    // console.log(officeVuexLoader)

  // Once everything's safely loaded into the store,
  // run the funciton that checks for query strings
  return this.checkForMode()

  } catch (error) {
    this.errorModal = true;
    console.error("Error loading NCDMV Office Locations from service " + this.getLocationsURL)
    console.error(error);
  }


  },
  
  // Handles query strings on the URL and adjusts toggles to update what's displayed in app
  checkForMode() {
    // Retrieve a query string
    function getUrlParameter(name) {
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      var results = regex.exec(location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    }



    // If it's 'closedonly' toggle everything off, show only closed locations on the map
    if (getUrlParameter("mode") === "closedonly") {
      return [
        this.rootStore.TOGGLE_SWITCH_DL(false),
        this.rootStore.TOGGLE_SWITCH_KIOSK_DL(false),
        this.rootStore.TOGGLE_SWITCH_KIOSK_VR(false),
        this.rootStore.TOGGLE_SWITCH_LPA(false),
        this.rootStore.TOGGLE_SWITCH_CLOSED(true),
        this.rootStore.SET_MAPMODE(true),
        console.log(
          "The Query String is set to display only the closed locations"
        )
      ]
    }

    // Support for office=type query strings
    if (getUrlParameter("office") === "driverlicense") {
      return [
        this.rootStore.TOGGLE_SWITCH_DL(true),
        this.rootStore.TOGGLE_SWITCH_KIOSK_DL(false),
        this.rootStore.TOGGLE_SWITCH_KIOSK_VR(false),
        this.rootStore.TOGGLE_SWITCH_LPA(false),
        this.rootStore.SET_MAPMODE(false),
        console.log(
          "The Query String is set to display only driver license offices"
        )
      ]
    }

    if (getUrlParameter("office") === "platevehicle") {
      return [
        this.rootStore.TOGGLE_SWITCH_DL(false),
        this.rootStore.TOGGLE_SWITCH_KIOSK_DL(false),
        this.rootStore.TOGGLE_SWITCH_KIOSK_VR(false),
        this.rootStore.TOGGLE_SWITCH_LPA(true),
        this.rootStore.SET_MAPMODE(false),
        console.log(
          "The Query String is set to display only license plate offices"
        )
      ]
    }

    if (getUrlParameter("office") === "licensetheft") {
      return [
        this.rootStore.TOGGLE_SWITCH_DL(false),
        this.rootStore.TOGGLE_SWITCH_KIOSK_DL(false),
        this.rootStore.TOGGLE_SWITCH_KIOSK_VR(false),
        this.rootStore.TOGGLE_SWITCH_LPA(false),
        this.rootStore.TOGGLE_SWITCH_LT(true),
        this.rootStore.SET_MAPMODE(false),
        console.log(
          "The Query String is set to display only license and theft offices"
        )
      ]
    }

    if (getUrlParameter("office") === "commercial") {
      return [
      this.rootStore.TOGGLE_SWITCH_DL(false),
      this.rootStore.TOGGLE_SWITCH_KIOSK_DL(false),
      this.rootStore.TOGGLE_SWITCH_KIOSK_VR(false),
      this.rootStore.TOGGLE_SWITCH_LPA(false),
      this.rootStore.TOGGLE_SWITCH_IRP(true),
      this.rootStore.SET_MAPMODE(false),
      console.log(
        "The Query String is set to display only IRP offices"
      )
      ]
    }

    if (getUrlParameter("office") === "saturday") {
      return[
        this.rootStore.TOGGLE_SWITCH_DL(false),
        this.rootStore.TOGGLE_SWITCH_KIOSK_DL(false),
        this.rootStore.TOGGLE_SWITCH_KIOSK_VR(false),
        this.rootStore.TOGGLE_SWITCH_LPA(false),
        this.rootStore.TOGGLE_SWITCH_DL_SATURDAY(true),
        this.rootStore.SET_MAPMODE(false),
        console.log(
          "The Query String is set to display only saturday DL offices"
        )
      ]
    }

    if (getUrlParameter("office") === "kiosk") {
      this.rootStore.TOGGLE_SWITCH_DL(false);
      this.rootStore.TOGGLE_SWITCH_KIOSK_DL(false);
      this.rootStore.TOGGLE_SWITCH_KIOSK_VR(false),
      this.rootStore.TOGGLE_SWITCH_LPA(false),
      this.rootStore.SET_MAPMODE(false);

      return [
      // this.rootStore.TOGGLE_SWITCH_KIOSK_DL(true),
      this.rootStore.SET_SHOWONLYKIOSK(true),
      this.rootStore.TOGGLE_SWITCH_KIOSK_DL(true),
      

      console.log(
        "The Query String is set to display only kiosk offices"
      )

      
      ]
    }

  },

  async enhanceUserLocationData(Lat, Long) {
    // http://dev.virtualearth.net/REST/v1/Locations/47.64054,-122.12934?o=xml&key={BingMapsAPIKey}
    var _url = "https://dev.virtualearth.net/REST/v1/Locations/";
    var _lat = Lat;
    var _long = Long;

    var _queryURL =
      _url + _lat + "," + _long + "?o=json&key=" + this.getMapAPIkey;

    var thisMethods = this;
    try {
      await fetch(_queryURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          Accept: "application/json, text/javascript",
        },
      })
        .then((response) => {
          if (!response.ok) {
            return Promise.reject(`Response status: ${response.status}`)
          }
          return response.json()
        })
        .then((data) => {
          var _loadedData = data.resourceSets[0].resources[0];

          var _loadedCounty = _loadedData.address.adminDistrict2;

          var _response = {};
          _response.Lat = _loadedData.point.coordinates[0];
          _response.Long = _loadedData.point.coordinates[1];
          _response.Zip = _loadedData.address.postalCode;
          _response.City = _loadedData.address.locality;
          _response.County = _loadedCounty.replace(" Co.", "");

          // Tech debt -figure out why it's making two calls
          if (_response.County !== "Hill County") {
            thisMethods.rootStore.SET_MAPAPI_RESPONSE(_response);
          }
        });
    } catch (error) {
      // this.errorModal = true;
      console.log(`Error loading enhanced user location data from service ${_url} and failed with ${error}`);
    }

  },
},
computed: {
  getLpaKioskAllowed(){
    return this.rootStore.lpaKioskAllowed;
  },
  getIsStateHoliday(){
    return this.rootStore.isStateHoliday;
  },
  getLocationsURL() {
    return this.rootStore.locationsURL;
  },
  getOfficeIRP() {
    return this.rootStore.officeIRP.length;
  },
  getUserLocation() {
    console.log('log the store value', this.rootStore.userLocation)
    return this.rootStore.userLocation;
  },
  getMapAPIkey() {
    return this.rootStore.mapAPIkey;
  },
  getMapAPIresponse() {
    return this.rootStore.mapAPIresponse;
  }
},
};
</script>
